import { Link, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PublicHeader } from "./PublicHeader";

export const PublicFooter = () => {
  const { t } = useTranslation();
  const links = [
    { to: "/", key: "pub.nav.home" },
    { to: "/events", key: "pub.nav.events" },
    { to: "/partners", key: "pub.nav.partners" },
    { to: "/about", key: "pub.nav.about" },
    { to: "/login", key: "pub.nav.login" },
  ];
  return (
    <footer className="border-t border-border bg-[hsl(221_83%_13%)] px-4 py-10 text-white sm:px-6"
      data-testid="public-footer">
      <div className="mx-auto max-w-6xl">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-start sm:justify-between">
          <div>
            <p className="font-display text-xl font-extrabold">
              Vytali<span className="text-accent">Days</span>
            </p>
            <p className="mt-1 text-sm text-white/60">{t("pub.footerTagline")}</p>
          </div>
          <nav className="flex flex-wrap gap-x-6 gap-y-2 text-sm font-semibold">
            {links.map((l) => (
              <Link key={l.to} to={l.to} data-testid={`footer-link-${l.to.replace("/", "") || "home"}`}
                className="text-white/80 transition-colors hover:text-accent">{t(l.key)}</Link>
            ))}
          </nav>
        </div>
        <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-2 border-t border-white/10 pt-6 text-xs text-white/50">
          <span>© {new Date().getFullYear()} Vytali</span>
          <Link to="/about" className="hover:text-white">{t("pub.footerPrivacy")}</Link>
          <Link to="/about" className="hover:text-white">{t("pub.footerTerms")}</Link>
          <Link to="/partners" className="hover:text-white">{t("pub.footerContact")}</Link>
        </div>
      </div>
    </footer>
  );
};

export const PublicLayout = ({ children }) => (
  <div className="min-h-screen bg-background">
    <PublicHeader />
    <main>{children || <Outlet />}</main>
    <PublicFooter />
  </div>
);
